import { toObject } from "../../core/utils";
import constants from "../../core/constants";
class PricingPageTransform {
  constructor() {
    "ngInject";
  }
  flattenObjectApplyToObject(item) {
    Object.keys(item).forEach((option) => {
      item[option] = {
        key: option,
        value:
          typeof item[option] === "boolean"
            ? item[option]
            : option === "one_day_span"
            ? item[option] / constants.fromHourToMilli
            : item[option] / constants.currencyBy,
        isDisabled: true,
      };
    });
  }
  justify(data) {
    data.pricing.one_way = {
      key: "one_way",
      value: data.pricing.one_way / constants.currencyBy,
      isDisabled: true,
    };
    this.flattenObjectApplyToObject(data.pricing.round_trip);
    data.options.is_one_way_allowed = {
      key: "is_one_way_allowed",
      value: data.options.is_one_way_allowed,
      isDisabled: true,
    };
    this.flattenObjectApplyToObject(data.options.is_round_trip_allowed);
    data.options.is_round_trip_allowed.on_another_day = {
      key: "is_on_another_day_allowed",
      value: data.options.is_round_trip_allowed.on_another_day.value,
      isDisabled: true,
    };
    data.options.is_round_trip_allowed.on_same_day = {
      key: "is_on_same_day_allowed",
      value: data.options.is_round_trip_allowed.on_same_day.value,
      isDisabled: true,
    };
    return toObject(data);
  }
}

export default PricingPageTransform;



// WEBPACK FOOTER //
// ./src/pages/pricing/pricing.transforms.js